import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Initialize WASM module - dynamic import for better error handling
async function initApp() {
  try {
    // Dynamic import to handle both dev and production paths
    const wasmModule = await import('@wasm/fertilcare_wasm.js');
    await wasmModule.default();
    console.log('🦀 WASM module loaded successfully');
    return wasmModule;
  } catch (error) {
    console.error('Failed to initialize WASM:', error);
    console.warn('Continuing without WASM functionality...');
    return null;
  }
}

initApp().then((wasm) => {
  // Store wasm reference globally if needed
  if (wasm) {
    (window as any).wasm = wasm;
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
});
